"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("@material-ui/core/Card");
const CardHeader_1 = require("@material-ui/core/CardHeader");
const Grid_1 = require("@material-ui/core/Grid");
const TextField_1 = require("@material-ui/core/TextField");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const CardBody_1 = require("../card/CardBody");
const SurveyScreenStyle_1 = require("./jss/SurveyScreenStyle");
class TextQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (event) => {
            const { question, onChange } = this.props;
            const value = event.target.value;
            this.setState({ value });
            onChange(question, value);
        };
        this.state = {
            value: ''
        };
    }
    componentDidMount() {
        var _a, _b;
        const { answer } = this.props;
        const value = (_b = (_a = answer === null || answer === void 0 ? void 0 : answer.text_answer) !== null && _a !== void 0 ? _a : answer === null || answer === void 0 ? void 0 : answer.value) !== null && _b !== void 0 ? _b : null;
        if (answer) {
            this.setState({ value });
        }
    }
    render() {
        const { question: { value }, questionIndex, theme } = this.props;
        const answer = this.state.value;
        return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ xs: 12, item: true, style: { paddingBottom: theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ style: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(CardHeader_1.default, { title: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", component: 'span', style: {
                                color: theme.palette.text.primary,
                                paddingTop: theme.spacing(4),
                                paddingBottom: theme.spacing(4),
                                textAlign: 'start'
                            } }, { children: value })), style: {
                            backgroundColor: theme.palette.grey.A200
                        } }), (0, jsx_runtime_1.jsx)(CardBody_1.default, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, style: { paddingBottom: theme.spacing(2) } }, { children: (0, jsx_runtime_1.jsx)(TextField_1.default, { placeholder: "Answer", fullWidth: true, margin: "normal", autoFocus: questionIndex === 0, onChange: this.handleChange, value: answer ? answer : '', inputProps: {
                                    'aria-label': `Answer`
                                } }) })) })] })) })));
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(SurveyScreenStyle_1.default)(TextQuestion));
//# sourceMappingURL=TextQuestion.js.map